import ProgressScale from "../Components/UI/ProgressScale";
import "chart.js/auto";
import IntroTestBlock from "../Components/Modules/Test/IntroTestBlock";
import StyledButton from "../Components/UI/StyledButton";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";
import TestApi from "../Api/TestApi";
import { useNavigate } from "react-router-dom";
import { directus } from "../Api/FetchDirectus";
import { readItems } from "@directus/sdk";

const IntroTestPage = () => {
  const navigate = useNavigate();
  const [unlockNext, setUnlockNext] = useState(false);
  const [loader, setLoader] = useState(false);
  const [questionData, setQuestionData] = useState(
    JSON.parse(localStorage.getItem("question") || "{}") || null
  );
  const competenciesList =
    JSON.parse(localStorage.getItem("competencies_list") || "{}") || null;
  const [labels, setLabels] = useState([]);
  const [chosenAnswerID, setChosenAnswerID] = useState([]);
  // const [finalOpen, setFinalOpen] = useState(false);
  const [testCount, setTestCount] = useState(
    Number(localStorage.getItem("test_count")) || 1
  );
  const [radarData, setRadarData] = useState<
    { category_id: string; category_score: number }[]
  >([]);
  // const [labelsData, setLabelsData] = useState<Record<string, any>[]>([]);

  const labelsDirectus = async () => {
    try {
      return await directus.request(readItems(`category`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchLabels() {
    let labelsList = [...(await labelsDirectus())];

    let truncatedList = competenciesList.map((item: string) => {
      return labelsList.find((label) => label.id.toString() === item);
    });

    setLabels(
      truncatedList.map((item: { name: string }) => item.name.split("/")[2])
    );
  }

  // let labelsList = [
  //   { id: "2", value: "Экономика" },
  //   { id: "3", value: "Спортивная медицина" },
  //   { id: "4", value: "Биомеханика" },
  //   { id: "5", value: "Физическая культура" },
  //   { id: "6", value: "Педагогика" },
  //   { id: "7", value: "Физиология мышц" },
  // ];

  const data = {
    labels: labels,
    datasets: [
      {
        data: radarData?.map((item) => item.category_score),
        fill: false,
        tension: 0.1,
      },
    ],
  };

  useEffect(() => {
    fetchLabels();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("radar_data")) {
      setRadarData(JSON.parse(localStorage.getItem("radar_data") || "[]"));
    } else {
      let emptyRadar: { category_id: string; category_score: number }[] = [];

      competenciesList.forEach((item: string) => {
        emptyRadar.push({ category_id: item, category_score: 0 });
      });

      setRadarData(emptyRadar);
    }
  }, []);

  async function onNextTest() {
    const data = {
      session_code: localStorage.getItem("session_code") || "",
      question_id: questionData.question.id,
      selected_answer_ids: chosenAnswerID,
    };

    setLoader(true);
    const nextTest = await TestApi.nextTest(data);

    if (nextTest.message === "Quiz completed") {
      navigate("/intro_test/result");
    } else if (nextTest.status === 200) {
      localStorage.setItem("question", JSON.stringify(nextTest.data));

      setTestCount(testCount + 1);
      setQuestionData(nextTest.data);

      const mergedArray = radarData.map((item2) => {
        const found = nextTest.scores.find(
          (item1) => JSON.stringify(item1.category_id) === item2.category_id
        );

        return found
          ? { ...item2, category_score: found.category_score }
          : item2;
      });

      setRadarData(mergedArray);
      localStorage.setItem("radar_data", JSON.stringify(mergedArray));
      localStorage.setItem("radar_labels", JSON.stringify(labels));
      setLoader(false);
    }
  }

  useEffect(() => {
    localStorage.setItem("test_count", JSON.stringify(testCount));
  }, [testCount]);

  return (
    <div className="coursesListPage">
      <div className="test">
        <div className="headTestBlock">
          <div className="courseBlockText testBlockText">
            <div>
              <h1>Тест на определение профессиональных компетенций</h1>
              <div className="headCourseBlockDescription">
                Пройдите тестирование, чтобы определить свой уровень
                профессиональных компетенций и подобрать онлайн-курс
              </div>
            </div>
            <div className="moduleScaleBox">
              <span>
                Прохождение теста: {testCount} вопросов из{" "}
                {localStorage.getItem("total_question")}
              </span>
              <ProgressScale
                scale={testCount}
                max={Number(localStorage.getItem("total_question"))}
              />
            </div>
          </div>
        </div>

        <IntroTestBlock
          question={questionData.question}
          answerList={questionData.answers}
          radarData={data}
          chosen={(e: boolean) => setUnlockNext(e)}
          chosenAnswerID={(e: any) => setChosenAnswerID(e)}
        />
        <div className="nextTestBox">
          {loader ? (
            <div>
              <ReactLoading
                type="spinningBubbles"
                color="black"
                height={"50px"}
                width={"50px"}
              />
            </div>
          ) : (
            <StyledButton
              text="ОТВЕТИТЬ"
              className={
                unlockNext ? "blueButton" : "greyButton disabledButton"
              }
              onClick={unlockNext ? () => onNextTest() : null}
            />
          )}
        </div>
      </div>
      {/* {finalOpen && <FinalPopUp />} */}
    </div>
  );
};

export default IntroTestPage;
